import PropTypes from "prop-types";

const BtnPrimaryM = ({ buttonCTA, onClickLink, type, className }) => {
  // If onClickLink is a string, it's an external link
  if (typeof onClickLink === "string") {
    return (
      <a
        href={onClickLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`btn-primary-m text-base md:text-sm ${className ?? ""}`}
      >
        {buttonCTA}
      </a>
    );
  }

  return (
    <button
      className={`btn-primary-m text-base md:text-sm ${className ?? ""}`}
      onClick={onClickLink}
      type={type}
    >
      {buttonCTA}
    </button>
  );
};

BtnPrimaryM.propTypes = {
  buttonCTA: PropTypes.string.isRequired,
  onClickLink: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  type: PropTypes.string,
  className: PropTypes.string,
};

export default BtnPrimaryM;
